export interface SpacingConfig {
  all?: string;
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
}
